import {
  Alert,
  Box,
  Button,
  Flex,
} from 'app/components/design-system-components'
import Card from 'app/components/design-system-components/Card'
import { LockOpenRounded } from 'app/components/design-system-components/icons/actions'
import { fontSizes } from 'app/components/design-system-components/styles/variables'
import { Text } from 'app/components/design-system-components/typography'
import { history } from 'app/shared_components/router'
import SnugLogo from 'app/shared_components/snug_logo'
import * as helpers from 'app/sm/helpers'
import { SessionStorageUtils } from 'app/storage_utils'

interface RequestLoginAccessProps {
  backUrl: string
}

const RequestLoginAccess = ({ backUrl }: RequestLoginAccessProps) => {
  const onLoginButtonClick = () => {
    SessionStorageUtils.setItem('forwardUrl', backUrl)
    history.push(helpers.urlTo(helpers.urlIds.join.index))
  }

  return (
    <Flex justifyContent="center" alignItems="center" height="60vh">
      <Card
        internalComponent={
          <Box px={5}>
            <Box mb={8}>
              <SnugLogo
                height={'30'}
                className={undefined}
                wrapperClassName={undefined}
              />
            </Box>
            <Text as="h3" mb={5} fontSize={fontSizes[10] + 'px'}>
              Log in to viewing the Lease Offer
            </Text>
            <Alert variant="blueWithBg">
              <Flex alignItems="center" justifyContent="center">
                <img
                  src="https://snugco.s3.ap-southeast-2.amazonaws.com/assets/img/shield-lock2.png"
                  alt="shield"
                  height="20px"
                  width="20px"
                />{' '}
                <Box ml={4} fontSize={fontSizes[4] + 'px'}>
                  All requests are tracked for security and privacy
                </Box>
              </Flex>
            </Alert>
            <Button mt={8} mb={4} sizeVariant="large" width="120px">
              <Flex alignItems="center" justifyContent="center">
                <LockOpenRounded height="20px" width="20px" />{' '}
                <Box ml={4} onClick={onLoginButtonClick}>
                  Login
                </Box>
              </Flex>
            </Button>
          </Box>
        }
        headerTitle={undefined}
        headerImage={undefined}
      />
    </Flex>
  )
}

export default RequestLoginAccess
